export const Api = {
  LOGIN: '/authentication/login',
  SERVICE_ORDERS: '/service-orders',
  VEHICLE: '/vehicle',
  USERS:'/users',
  PARAMS:'/parameters'
}
